import {Injectable} from '@angular/core';
import {LokijsService} from '../database/lokijs.service';
import {ServiceJobDTOModel} from '../../models/service-job-DTO.model';
import {DocumentModel} from '../../models/document.model';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {ConfigurationService} from '../configuration.service';
import {AlertController} from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class ValidateWsJobService {

    mobileConfiguration: MobileConfigurationModel;

    constructor(private loki: LokijsService,
                private configService: ConfigurationService,
                private alertController: AlertController) {
    }

    // validateServiceJob(doc: DocumentModel): boolean {
    //     return this.checkMinRequirements(doc) && doc.serviceJob.jobStatus === 7 ? this.checkMandatoryReadings(doc.serviceJob) : true;
    // }

    validateServiceJob(doc: DocumentModel): boolean {
        this.mobileConfiguration = this.configService.getMobileConfiguration();
        let msg = '';
        if (doc.documentNumber !== 0) {
            if (!doc.serviceJob.servicedItem.pdesc && !doc.customer.name) {
                msg += 'No serviced item or customer selected\n';
            }
            let invalidJobType = false;
            for (const jobType of this.mobileConfiguration.mobilehireRestrictServiceJobTypes) {
                if (doc.serviceJob.jobTypeId === jobType) {
                    invalidJobType = true;
                    break;
                }
            }

            if (invalidJobType) {
                msg += 'Select a Job Type\n';
            }
        }

        if (!doc.serviceJob.servicedItem || (!doc.serviceJob.servicedItem.pdesc && !doc.serviceJob.servicedItem.plu)) {
            msg += 'Please select an Item to be serviced\n';
        }

        if (doc.serviceJob.servicedItem && doc.serviceJob.servicedItem.plu && !doc.serviceJob.servicedItem.serial) {
            msg += 'Please inform the serial\n';
        }

        if (doc.serviceJob.servicedItem && doc.serviceJob.servicedItem.plu && (!doc.customer || !doc.customer.name)) {
            msg += 'Please select a customer\n';
        }

        if (doc.clockingState === 2) {
            msg += 'Please stop the time clock\n';
        }

        if (msg.length > 0) {
            this.alertInvalidReasons(msg);
        }

        return msg.length <= 0;
    }

    checkMandatoryReadings(job: ServiceJobDTOModel): boolean {
        const meterReadingsMissing = [];
        const mandatoryTemp = this.loki.getCollection('mandatorymeters')
            .chain().find({jobType: job.jobTypeId, pdesc: job.servicedItem.pdesc}).data();
        const mandatoryReading = JSON.parse(JSON.stringify(mandatoryTemp));
        if (mandatoryReading.length <= 0) {
            return true;
        } else if (mandatoryReading.length > 0) {
            for (const mandR of mandatoryReading) {
                for (const mr of job.meterReadings) {
                    if (mandR.meterName === mr.description) {
                        mandR.isChecked = true;
                    }
                }
            }
        }
        for (const mandR of mandatoryReading) {
            if (!mandR.isChecked) {
                meterReadingsMissing.push(mandR.meterName);
            }
        }

        if (meterReadingsMissing.length > 0) {
            this.alertMeterReadings(meterReadingsMissing.join('\n'));
        }

        return meterReadingsMissing.length <= 0;
    }

    handleSignature(doc): boolean {
        if (this.mobileConfiguration.mobilehireServiceRequireEngineerSigForCompletion) {
            return !!doc.engineerSignature;
        } else {
            return true;
        }
    }

    async alertInvalidReasons(msg: string) {
        const alert = await this.alertController.create({
            header: 'Requirements Missing',
            backdropDismiss: false,
            message: msg,
            buttons: [
                {
                    text: 'Ok',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }
            ]
        });
        await alert.present();
    }

    async alertMeterReadings(msg: string) {
        const alert = await this.alertController.create({
            header: 'Readings Missing',
            backdropDismiss: false,
            message: msg,
            buttons: [
                {
                    text: 'Ok',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }
            ]
        });
        await alert.present();
    }
}
